import type { RouteRecordRaw } from 'vue-router'

const lubOilSamplesRoutes: RouteRecordRaw[] = [
  {
    path: '/lub-oil-samples',
    name: 'lub-oil-samples.index',
    component: () => import('@/modules/technical/lub-oil-samples/views/LubOilSamplesIndex.vue'),
    meta: {
      pageTitle: 'Lub oil samples',
      breadcrumbs: ['Lub oil samples']
    }
  },
  {
    path: '/lub-oil-samples/create',
    name: 'lub-oil-samples.create',
    component: () => import('@/modules/technical/lub-oil-samples/views/LubOilSamplesEdit.vue'),
    meta: {
      pageTitle: 'Lub oil samples',
      breadcrumbs: ['Lub oil samples']
    }
  },
  {
    path: '/lub-oil-samples/:id/edit',
    name: 'lub-oil-samples.edit',
    component: () => import('@/modules/technical/lub-oil-samples/views/LubOilSamplesEdit.vue'),
    meta: {
      pageTitle: 'Lub oil samples',
      breadcrumbs: ['Lub oil samples']
    }
  }
]

export default lubOilSamplesRoutes
